(function () {
  (function () { var st = document.createElement('style'); st.textContent = "header-menu a.menu-list__link[href*=\"/collections/ofertas\"], header-menu a.menu-list__link[href*=\"/collections/ofertas\"] .menu-list__link-title, header-menu .menu-list__list-item:hover a.menu-list__link[href*=\"/collections/ofertas\"] { color: #d32f2f !important; font-weight: 800 !important; } .emd-tile.emd-tile--sale { background: #d32f2f !important; color: #ffffff !important; } .emd__view[data-view=\"mas\"] .em-label:has(+ .emd-links + .em-vids--m) { display: inline-block; margin: 20px 0 10px 16px; padding: 7px 14px; border-radius: 999px; background: #111111; color: #F5D000; font-size: 12px; } .emd__view[data-view=\"mas\"] .em-label:has(+ .emd-links + .emd-formwrap) { display: inline-block; margin: 20px 0 10px 16px; padding: 6px 14px; border-radius: 999px; box-shadow: inset 0 0 0 2px #111111; color: #111111; font-size: 12px; } header-menu .menu-list__list-item:has(a.menu-list__link[href*=\"#comunidad\"]) { margin-left: 10px; padding-left: 14px; border-left: 2px solid rgba(17,17,17,.25); } header-menu .menu-list__list-item:has(a.menu-list__link[href*=\"/pages/conocenos\"]) { margin-left: 12px; } header-menu a.menu-list__link[href*=\"#comunidad\"], header-menu a.menu-list__link[href*=\"/pages/conocenos\"] { border-radius: 999px; padding: 7px 16px !important; font-weight: 800 !important; text-decoration: none !important; line-height: 1.1; } header-menu a.menu-list__link[href*=\"#comunidad\"], header-menu a.menu-list__link[href*=\"#comunidad\"] .menu-list__link-title { background: #111111; color: #F5D000 !important; } header-menu a.menu-list__link[href*=\"#comunidad\"] .menu-list__link-title { background: transparent; } header-menu a.menu-list__link[href*=\"/pages/conocenos\"] { box-shadow: inset 0 0 0 2px #111111; color: #111111 !important; } header-menu a.menu-list__link[href*=\"/pages/conocenos\"]:hover { background: #111111; color: #ffffff !important; } header-menu a.menu-list__link[href*=\"/pages/conocenos\"]:hover .menu-list__link-title { color: #ffffff !important; } header-menu .menu-list__list-item.em-on a.menu-list__link[href*=\"#comunidad\"], header-menu .menu-list__list-item.em-on a.menu-list__link[href*=\"/pages/conocenos\"] { text-decoration: none !important; box-shadow: inset 0 0 0 2px #111111, 0 0 0 3px rgba(17,17,17,.2); }"; document.head.appendChild(st); })();
  var root = document.querySelector('[data-endure-menu]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  document.body.appendChild(root);
  var panels = {};
  root.querySelectorAll('[data-em-panel]').forEach(function (p) { panels[p.dataset.emPanel] = p; });
  var drawer = root.querySelector('[data-endure-drawer]');

  function slug(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }

  /* ---------- Computador ---------- */
  var openKey = null, closeTimer = null, curLi = null, activeLi = null;
  function headerBottom() { var h = document.querySelector('#header-component'); return h ? Math.max(0, h.getBoundingClientRect().bottom) : 0; }
  function setActive(li) { if (activeLi) activeLi.classList.remove('em-on'); activeLi = li || null; if (activeLi) activeLi.classList.add('em-on'); }
  function openPanel(key) {
    clearTimeout(closeTimer);
    if (openKey && openKey !== key && panels[openKey]) { panels[openKey].classList.remove('is-open'); panels[openKey].hidden = true; }
    var p = panels[key]; if (!p) { closeAll(true); return; }
    p.style.top = headerBottom() + 'px';
    p.hidden = false;
    p.querySelectorAll('.em-combo__row').forEach(function (r) { var off = [].some.call(r.querySelectorAll('a'), function (a) { return a.style.display === 'none'; }); r.style.display = off ? 'none' : ''; });
    requestAnimationFrame(function () { p.classList.add('is-open'); });
    openKey = key; setActive(curLi);
  }
  function typing() { var a = document.activeElement; return openKey && panels[openKey] && panels[openKey].contains(a) && /INPUT|TEXTAREA|SELECT/.test(a.tagName); }
  function closeAll(now) {
    clearTimeout(closeTimer);
    var run = function () {
      if (typing()) return;
      Object.keys(panels).forEach(function (k) { panels[k].classList.remove('is-open'); panels[k].hidden = true; });
      openKey = null; curLi = null; setActive(null);
    };
    if (now) run(); else closeTimer = setTimeout(run, 180);
  }
  function keyOf(li) { var t = li.querySelector('.menu-list__link-title') || li.querySelector('.menu-list__link'); return t ? slug(t.textContent) : ''; }
  function hoverLi(li) {
    clearTimeout(closeTimer);
    if (li === curLi && openKey) return;
    curLi = li;
    var key = keyOf(li);
    if (panels[key]) openPanel(key); else closeAll(true);
  }
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType === 'touch' || !e.target.closest) return;
    var li = e.target.closest('header-menu .menu-list__list-item');
    if (li) { hoverLi(li); return; }
    if (e.target.closest('[data-em-panel]')) { clearTimeout(closeTimer); return; }
    if (openKey) closeAll(false);
  });
  document.addEventListener('focusin', function (e) {
    if (!e.target.closest) return;
    var li = e.target.closest('header-menu .menu-list__list-item');
    if (li) hoverLi(li);
  });
  document.documentElement.addEventListener('pointerleave', function () { if (openKey) closeAll(false); });
  Object.keys(panels).forEach(function (k) {
    panels[k].addEventListener('focusout', function (e) { if (!panels[k].contains(e.relatedTarget)) closeAll(false); });
  });
  window.addEventListener('scroll', function () { if (openKey && panels[openKey]) panels[openKey].style.top = headerBottom() + 'px'; }, { passive: true });

  /* ---------- Celular ---------- */
  var lastFocus = null, curTab = 'root';
  function show(name) {
    drawer.querySelectorAll('[data-view]').forEach(function (v) { v.hidden = v.dataset.view !== name; });
    var tabName = name;
    drawer.querySelectorAll('[data-tab]').forEach(function (b) { var on = b.dataset.tab === tabName; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on); });
    drawer.querySelector('.emd__panel').scrollTop = 0;
  }
  function openDrawer() {
    lastFocus = document.activeElement; show(curTab);
    drawer.hidden = false; document.documentElement.classList.add('em-noscroll');
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    var x = drawer.querySelector('.emd__x'); if (x) x.focus({ preventScroll: true });
  }
  function closeDrawer() {
    drawer.classList.remove('is-open'); document.documentElement.classList.remove('em-noscroll');
    setTimeout(function () { drawer.hidden = true; }, 250);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', function (e) {
    var s = e.target.closest && e.target.closest('header-drawer summary');
    if (!s) return;
    e.preventDefault(); e.stopImmediatePropagation(); openDrawer();
  }, true);
  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-emd-close]')) { closeDrawer(); return; }
    var t = e.target.closest('[data-tab]'); if (t) { curTab = t.dataset.tab; show(curTab); return; }
    var o = e.target.closest('[data-open]'); if (o) { show(o.dataset.open); return; }
    var b = e.target.closest('[data-back]'); if (b) { show(b.dataset.back); return; }
    if (e.target.closest('a[href*="#"]')) closeDrawer();
  });
  document.addEventListener('keydown', function (e) { if (e.key !== 'Escape') return; if (!drawer.hidden) closeDrawer(); if (openKey) { var a = document.activeElement; if (a && a.blur) a.blur(); closeAll(true); } });

  /* ---------- Formulario enviado ---------- */
  if (/[?&]contact_posted=true/.test(location.search)) {
    var toast = root.querySelector('[data-em-toast]');
    if (toast) { toast.hidden = false; setTimeout(function () { toast.hidden = true; }, 6000); }
  }

})();
